import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import ErrorPage from "./pages/ErrorPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PrivateRoute from "./components/PrivateRoute";
import SignInPage from "./pages/SignInPage";

import ManageCategoryPage from "./pages/ManageCategoryPage";
import UsersListPage from "./pages/UsersListPage";
import BlogListPage from "./pages/BlogListPage";
import AddBlogPage from "./pages/AddBlogPage";
import EditBlogPage from "./pages/EditBlogPage";
// import ManageAdminPage from "./pages/ManageAdminPage";
// import AllBusinesEnquiriesPage from "./pages/AllBusinesEnquiriesPage";
import SiteDetailsPage from "./pages/SiteDetailsPage";
import ContactListPage from "./pages/ContactListPage";
// import ActiveBusinessesPage from "./pages/ActiveBusinessesPage";
// import EditBusinessPage from "./pages/EditBusinessPage";
import AdminMessagesPage from "./pages/AdminMessagesPage"
// import RewardProductListPage from "./pages/RewardProductListPage"
// import RedeemProductHistoryListPage from "./pages/RedeemProductHistoryListPage"
// import InvoicePage from "./pages/InvoicePage"
// import LeaderboardPage from "./pages/LeaderboardPage"
// import UserPointsTxnHistoryPage from "./pages/UserPointsTxnHistoryPage";
import PlansListPage from "./pages/PlansListPage";
import CreatePlanPage from "./pages/CreatePlanPage";
import EditPlanPage from "./pages/EditPlanPage";
import TransactionsPage from "./pages/TransactionsPage";
import BlogCategoryPage from "./pages/BlogCategoryPage";
import EditPropertyPage from "./pages/EditPropertyPage";
import PropertyListPage from "./pages/PropertyListPage";


function App() {

  return (

    <BrowserRouter>

      <RouteScrollToTop />

      <Routes>

        <Route path="/login" element={<SignInPage />} />

        {/* 🔐 Protected Routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<HomePageOne />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/all-users" element={<UsersListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/create-plan" element={<CreatePlanPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/plans" element={<PlansListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/edit-plan/:id" element={<EditPlanPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/transactions" element={<TransactionsPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/add-blog" element={<AddBlogPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/edit-blog/:id" element={<EditBlogPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/all-blogs" element={<BlogListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-categories" element={<ManageCategoryPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-blog-categories" element={<BlogCategoryPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/contacts" element={<ContactListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/update-site-details" element={<SiteDetailsPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/admin-message" element={<AdminMessagesPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/properties-list" element={<PropertyListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/edit-property/:id" element={<EditPropertyPage />} />
        </Route>


        {/* <Route element={<PrivateRoute />}>
          <Route path="/active-businesses" element={<ActiveBusinessesPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-admin" element={<ManageAdminPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/reward-products" element={<RewardProductListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/product-redeem-history" element={<RedeemProductHistoryListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/view-invoice/:orderId" element={<InvoicePage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/leaderboard" element={<LeaderboardPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/points-transaction-history/:id" element={<UserPointsTxnHistoryPage />} />
        </Route>
        
        */}

        {/* ❌ Fallback */}
        <Route path="*" element={<ErrorPage />} />

      </Routes>

    </BrowserRouter>

  );
}

export default App;
